import * as React from 'react';
import Button from '@telia-front/button';
import { TableCell } from '@telia-front/table';
const PacketTableCell = (props) => {
    const { width, packet } = props;
    return (React.createElement(TableCell, { type: "th", className: "text-normal", scope: "col", width: width },
        React.createElement("p", { className: "h4 text-bold" }, packet.name),
        packet.channelsAmount && React.createElement("p", { className: "text-light text-small" }, packet.channelsAmount),
        packet.price && React.createElement("p", { className: "text-bold" }, packet.price),
        packet.orderButton && React.createElement(Button, Object.assign({ link: true, iconRight: "#arrow-right", iconRightSize: "xxs" }, packet.orderButton))));
};
export default PacketTableCell;
